import { Component, Injector, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JkBaseOption, jkRestReturn } from 'jk-service';
import { MaterialModule } from 'jk-service';
import { UtymcService, templateUrlConfigUty } from '../_service_uty';
import { Utymc } from '../_entity_uty';
import { JkDialogEditComponent } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';


@Component({
  selector: 'app-utymc-edit',
  templateUrl: './utymc-editPkg.component.html',
  styleUrls: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [JackBaseComponentModule, MaterialModule],
})

export class UtymcEditComponent extends JkDialogEditComponent<UtymcService, Utymc> {
  override dialogRef: MatDialogRef<UtymcEditComponent>;
  override data: jkRestReturn;

  override srv!: UtymcService;
  constructor() {
    const injector = inject(Injector);
    const dialogRef = inject<MatDialogRef<UtymcEditComponent>>(MatDialogRef);
    const data = inject<jkRestReturn>(MAT_DIALOG_DATA);

    super(injector, dialogRef, data);
  
    this.dialogRef = dialogRef;
    this.data = data;
  }


}
